import api from '../../utils/api';

// @ts-ignore
import { augmentError } from '../../utils/errors';

import type { MarketingLead, MarketUpdate } from '../../types/Marketing';

export const createMarketingLead = ({
  fullAddress = '',
  unit = '',
  email = null,
  urlQueryObject,
}: {
  fullAddress?: string;
  unit?: string;
  email?: string | null;
  urlQueryObject?: Record<string, string>;
}) => {
  return async () => {
    try {
      const { utm_source = '', utm_medium = '', utm_campaign = '', utm_content = '' } = urlQueryObject || {};

      if (__DEV__) {
        return;
      }

      const marketingLeadObject: MarketingLead = {
        fullAddress,
        unit,
        marketingLeadType: 'paidInclusionRentEstimator',
        utmSource: utm_source,
        utmMedium: utm_medium,
        utmCampaign: utm_campaign,
        utmContent: utm_content,
      };

      if (email) {
        marketingLeadObject.email = email;
      }

      await api.marketing.createMarketingLead(marketingLeadObject);

      return true;
    } catch (error) {
      const shouldLogAction = !error.data || !error.data.action;

      augmentError(error, {
        ...(shouldLogAction && {
          action: 'Error in MarketingActions#createMarketingLead',
        }),
      });

      throw error;
    }
  };
};

export const createMarketUpdate = (params: MarketUpdate) => {
  return async () => {
    try {
      const requiredParams = {
        email: params.email,
        zpid: params.zpid,
        price: params.price,
        lat: params.lat,
        lon: params.lon,
      };

      const optionalParams = {
        listingTypes: params.listingTypes || null,
        propertyTypes: params.propertyTypes || null,
        bedrooms: params.bedrooms || null,
        pets: params.pets || null,
        laundry: params.laundry || null,
        amenities: params.amenities || null,
        orderBy: params.orderBy || null,
        deactivatedDays: params.deactivatedDays || null,
        distanceInMiles: params.distanceInMiles || null,
      };

      const marketUpdateParams: MarketUpdate = Object.assign(requiredParams, optionalParams);

      if (__DEV__) {
        return;
      }

      await api.marketing.createMarketUpdate(marketUpdateParams);

      return true;
    } catch (error) {
      const shouldLogAction = !error.data || !error.data.action;

      augmentError(error, {
        ...(shouldLogAction && {
          action: 'Error in MarketingActions#createMarketUpdate',
        }),
        marketUpdateParams: params,
      });

      throw error;
    }
  };
};
